import { createPhaseActions, phaseAction } from 'src/helpers/redux'
import { TManualUserStatus } from 'src/services/auth/users'

export const PREFIX = 'presence'
export const PREFIX_SAGA = `${PREFIX}/saga`

export const actions = createPhaseActions(PREFIX_SAGA, {
  /** enter Ably presence and start following the team; safe to call more than once */
  start: phaseAction<{ channel: string }>(),
  /** dnd / offline pin the status, online returns it to automatic */
  setStatus: phaseAction<{ status: TManualUserStatus }>(),
  getTeam: phaseAction<void>(),
  /** live locations of teammates: only while somebody is looking at the team list */
  watchLocations: phaseAction<{ enabled: boolean }>(),
})

export type Actions = typeof actions
